import Axios from "axios";
import React from "react";
import { Spin } from "../loading";
import { BarChart } from "../bar-chart";
import { LineChart } from "../line-chart";
import { PieChart } from "../pie-chart";

interface ComplaintOverviewProps {}

interface State {
  lineChart: unknown[];
  pieChart: unknown[];
  barChart: unknown[];
  loading: boolean;
}

export const ComplaintOverview: React.FC<ComplaintOverviewProps> = (props) => {
  const [state, setState] = React.useState<State>({
    lineChart: [],
    pieChart: [],
    barChart: [],
    loading: false,
  });

  React.useEffect(() => {
    setState({ ...state, loading: true });
    Axios.get(`/complaint/overview`)
      .then((res) => {
        setState({
          ...state,
          lineChart: [{ label: "Complaint", data: res.data[0] }],
          pieChart: res.data[1],
          barChart: [{ label: "Complaint", data: res.data[2] }],
        });
      })
      .finally(() => {
        setState((prev) => ({
          ...prev,
          loading: false,
        }));
      });
  // eslint-disable-next-line
  }, []);

  return (
    <div className="overview">
      <span className="title">complaint overview</span>

      <div className="contract">
        {/* <span className="title">This Contract</span> */}
        <Spin spin={state.loading}>
          <LineChart data={state.lineChart} />
        </Spin>
      </div>

      <div>
        <span className="title">Latest Month</span>
        <div className="latest">
          <div className="left">
            <Spin spin={state.loading}>
              <PieChart
                data={state.pieChart.map((row: any) => row.value)}
                labels={state.pieChart.map((row: any) => row.id)}
              />
            </Spin>
          </div>

          <div className="right">
            <Spin spin={state.loading}>
              <BarChart data={state.barChart} />
            </Spin>
          </div>
        </div>
      </div>
    </div>
  );
};
